import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './AddMenu.css';
import AddMenuForm from '../../../components/Shop/ManageMenu/AddMenu/AddMenuForm'
import { graphql } from 'react-apollo'
import { flowRight as compose } from 'lodash';
import getShopCategoryIcons from '../../../actions/ShopCategoryIcon/getShopCategoryIcons.graphql'
import Loader from '../../../components/Common/Loader/Loader';


class AddMenu extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  render() {
    let initialValues = {};
    // Prepare for MenuAvailability
    let menuAvailableSettings = [
      { operationDay: 'Sunday', isOpen: true, isWholeDay: "true" },
      { operationDay: 'Monday', isOpen: true, isWholeDay: "true" },
      { operationDay: 'Tuesday', isOpen: true, isWholeDay: "true" },
      { operationDay: 'Wednesday', isOpen: true, isWholeDay: "true" },
      { operationDay: 'Thursday', isOpen: true, isWholeDay: "true" },
      { operationDay: 'Friday', isOpen: true, isWholeDay: "true" },
      { operationDay: 'Saturday', isOpen: true, isWholeDay: "true" },
    ];
    initialValues = {
      menuAvailability: menuAvailableSettings
    };

    const iconsOptions = this.props.iconsData?.getShopCategoryIcons?.results;

    if(!iconsOptions){
      return <Loader type="page" show />;
    }


    return (
      <div>
        <div>
          <AddMenuForm
            initialValues={initialValues}
            iconOptions={iconsOptions}
          />
        </div>
      </div>
    );
  }
}

export default compose(
  withStyles(s),
  graphql(getShopCategoryIcons, {
    name: 'iconsData',
    options: {
      fetchPolicy: 'network-only',
      ssr: false,
    },
  })
)(AddMenu);
